import React from 'react';
import { motion } from 'framer-motion';
import { Navbar, ContactCTA, Footer } from '../../components';
import styles from './Team.module.css';

const fadeUp = (delay = 0) => ({
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut', delay } },
});
const TeamMembers = [
  {
    id: 1,
    name: 'Chioma Okpalugo',
    position: 'Manging Director/Chief Executive Officer',
    image: 'https://res.cloudinary.com/dhjzovpof/image/upload/v1781880107/WhatsApp_Image_2026-06-19_at_12.03.50_PM_zoasbo.jpg'  },
  {
    id: 2,
    name: 'Ugochukwu A. Okpalugo',
    position: 'Chief Operating Officer',
    image: 'https://res.cloudinary.com/dhjzovpof/image/upload/v1780497193/_BNG5803bvgfg.jpg_qtounm.jpg'
  },
  {
    id: 3,
    name: 'Ikechukwu J. Okpalugo',
    position: 'Chief Logistics Officer/Supervisor',
    image: 'https://res.cloudinary.com/dhjzovpof/image/upload/v1780497855/WhatsApp_Image_2026-06-03_at_2.25.57_PM_d7tzsw.jpg'
  },
  {
    id:4,
    name: "Chinwe Okpalugo",
    position:"Administrative Officer",
    image:"https://res.cloudinary.com/dhjzovpof/image/upload/v1780595609/WhatsApp_Image_2026-06-04_at_6.49.18_PM_ieslx5.jpg"
  },
  {
    id:5,
    name: "Ebere Okpalugo",
    position: "Project Supervisor",
    image:"https://res.cloudinary.com/dhjzovpof/image/upload/v1782643841/WhatsApp_Image_2026-06-23_at_7.12.05_PM_ppervq.jpg"
  }
];

const STAFF_ROWS = [
  { position: 'Civil Engineers',      employ: 4, totalYears: 15, similarYears: 12, managerYears: 12 },
  { position: 'Mechanical Engineers', employ: 4, totalYears: 10, similarYears: 8,  managerYears: 8  },
  { position: 'Electrical Engineers', employ: 4, totalYears: 10, similarYears: 6,  managerYears: 6  },
  { position: 'Project Managers',     employ: 4, totalYears: 9,  similarYears: 5,  managerYears: 5  },
  { position: 'Welders',              employ: 3, totalYears: 15, similarYears: 12, managerYears: 12 },
  { position: 'Draftsmen',            employ: 3, totalYears: 12, similarYears: 8,  managerYears: 8  },
  { position: 'Plant Technician',     employ: 3, totalYears: 12, similarYears: 10, managerYears: 10 },
  { position: 'Site Manager',         employ: 3, totalYears: 10, similarYears: 6,  managerYears: 6  },
];

export default function Team() {
  return (
    <div className={styles.page}>
      <Navbar theme="light" cta="Contact Us" ctaTo="/contact" />

      {/* ── HERO ─────────────────────────────────────────── */}
      <section className={styles.hero}>
        <div className={styles.heroLabel}>
          <h1 className={styles.heroTitle}>MEET THE TEAM</h1>
        </div>
      </section>

      {/* ── TALENTED TEAM ────────────────────────────────── */}
      <section className={styles.talentSection}>
        <motion.div
          className={styles.talentHeader}
          variants={fadeUp(0)}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
        >
          <h2 className={styles.talentTitle}>Talented Team</h2>
          <p className={styles.talentBody}>
            A strategic vision does not define a company's success, its people do. We have some of
            the most talented and technically advanced team members in the industry and our clients
            can attest to that. All team members are encouraged to ask questions, make
            recommendations, and continuously improve systems and techniques. We encourage an
            environment of collaboration, knowledge sharing, and innovation, which translates to
            better service for our clients.
          </p>
        </motion.div>

        <div className={styles.talentGrid}>

          {TeamMembers.map((item, index) =>{
           return <motion.div
                className={styles.talentColCenter}
                variants={fadeUp(0.08)}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
            >
              <img src={item.image} alt="Team member" className={styles.talentPhoto} />
             <div className={styles.talentInfo}>
               <h3 className={styles.talentName}>{item.name}</h3>
               <p className={styles.talentPosition}>{item.position}</p>
             </div>
            </motion.div>
          })}

        </div>
      </section>

      {/* ── OTHER KEY PERSONELS + TABLE ───────────────────── */}
      <section className={styles.keySection}>
        {/* Gradient card */}
        <motion.div
          className={styles.keyCard}
          variants={fadeUp(0)}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          <div className={styles.keyInfo}>
            <h3 className={styles.keyInfoTitle}>Other Key Personnel</h3>
            <p className={styles.keyInfoBody}>
              There are also short and long term technicians, engineers and employees that have been
              designated different roles to ensure the success of any project, strictly adhering to
              the highest stands in optimal work output also in health and safety.
            </p>
          </div>
        </motion.div>

        {/* Staff table */}
        <motion.div
          className={styles.tableWrapper}
          variants={fadeUp(0.1)}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
        >
          <table className={styles.table}>
            <thead>
              <tr>
                <th className={styles.th}>POSITION</th>
                <th className={styles.th}>NO. IN OUR EMPLOY</th>
                <th className={styles.th}>TOTAL YEARS OF EXPERIENCE</th>
                <th className={styles.th}>YEARS OF EXPERIENCE IN SIMILAR WORKS</th>
                <th className={styles.th}>EXPERIENCE AS A MANAGER IN SIMILAR WORKS</th>
              </tr>
            </thead>
            <tbody>
              {STAFF_ROWS.map((row, i) => (
                <tr key={i} className={i % 2 === 0 ? styles.trEven : styles.trOdd}>
                  <td className={`${styles.td} ${styles.tdPosition}`}>{row.position}</td>
                  <td className={styles.td}>{row.employ}</td>
                  <td className={styles.td}>{row.totalYears}</td>
                  <td className={styles.td}>{row.similarYears}</td>
                  <td className={styles.td}>{row.managerYears}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </motion.div>
      </section>

      <ContactCTA />
      <Footer />
    </div>
  );
}
